import React, { useEffect, useRef } from 'react';

const Experience = () => {
  const screensRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const images = entry.target.querySelectorAll('.app-screen');
            images.forEach((img, index) => {
              setTimeout(() => {
                img.classList.add('animate-in');
              }, index * 150);
            });
          }
        });
      },
      { threshold: 0.2 }
    );

    if (screensRef.current) {
      observer.observe(screensRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="w-full max-w-[1400px] px-4 py-20 md:px-10 overflow-hidden">
      <h2 className="text-white text-3xl md:text-4xl font-bold text-center mb-4">Experience the App</h2>
      <p className="text-text-muted text-center mb-12">Everything you need to manage your finances, beautifully.</p>
      <div ref={screensRef} className="flex overflow-x-auto gap-6 pb-8 snap-x snap-mandatory scrollbar-hide md:justify-center">
        {/* Login Screen */}
        <div className="snap-center flex-shrink-0 app-screen opacity-0 translate-y-8 transition-all duration-700 ease-out">
          <div className="relative w-[280px] aspect-[9/19] rounded-[2.5rem] shadow-2xl shadow-primary/10 overflow-hidden">
            <img 
              src="/login.png" 
              alt="UPI Trackr login screen"
              className="w-full h-full object-cover"
            />
          </div>
          <p className="text-center text-white text-sm font-medium mt-4">Login</p>
        </div>

        {/* Dashboard Screen */}
        <div className="snap-center flex-shrink-0 app-screen opacity-0 translate-y-8 transition-all duration-700 ease-out">
          <div className="relative w-[280px] aspect-[9/19] rounded-[2.5rem] shadow-2xl shadow-primary/10 overflow-hidden">
            <img 
              src="/dashboard-new.png" 
              alt="Dashboard with expense tracking"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <p className="text-center text-white text-sm font-medium mt-4">Dashboard</p>
        </div>

        {/* QR Scanner Screen */}
        <div className="snap-center flex-shrink-0 app-screen opacity-0 translate-y-8 transition-all duration-700 ease-out">
          <div className="relative w-[280px] aspect-[9/19] rounded-[2.5rem] shadow-2xl shadow-primary/10 overflow-hidden bg-[#0b1121]">
            <img 
              src="/merchant-details.png" 
              alt="QR code scanner interface"
              className="w-full h-full object-contain"
            />
          </div>
          <p className="text-center text-white text-sm font-medium mt-4">Merchant Details</p>
        </div>

        {/* Analytics Screen */}
        <div className="snap-center flex-shrink-0 app-screen opacity-0 translate-y-8 transition-all duration-700 ease-out">
          <div className="relative w-[280px] aspect-[9/19] rounded-[2.5rem] shadow-2xl shadow-primary/10 overflow-hidden">
            <img 
              src="/analytics.png" 
              alt="Analytics and insights"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <p className="text-center text-white text-sm font-medium mt-4">Analytics</p>
        </div>
      </div>
    </section>
  );
};

export default Experience;
